@defer (when documentOwners()) {
  @for(member of documentOwners(); track member.id) {
    <div class="list-item">
      <div class="list-item-image">
        @if (member.owner.picture) {
          @let thumbnailUrl = member.owner.picture | thumbnail;
          <img class="list-item-image-container" [ngSrc]="thumbnailUrl" width="70" height="70" alt="Avatar de {{ member.owner.name }}" loading="lazy">
        } @else {
          <div class="list-item-image-container">
            <span class="default-avatar">{{ getInitialsFrom(member) }}</span>
          </div>
        }
      </div>
      <div class="list-item-content">
        <div class="list-item-content-left">
          <div class="list-item-subtitle"  >
            <span
              matBadge="Tú"
              matBadgeSize="medium"
              [matBadgeOverlap]="false"
              [matBadgePosition]="'after'"
              [matBadgeHidden]="!isCurrentUser(member)"
            >
              {{member.owner.name}}
            </span>
          </div>
          <div class="list-item-title">
            <span>{{userRoles[member.owner_id]}}</span>
          </div>
          <span class="list-item-detail">

            <span class="identifier">Miembro desde el {{ member.created_at | date: 'shortDate' }}</span>
          </span>
        </div>
        <div class="list-item-content-right">
          @if (isCurrentUser(member) || (isAdmin() | async) === true) {
            @let member_name = member.owner.name;
            <button
              mat-icon-button
              [matTooltip]="isCurrentUser(member) ? 'Dejar de ser miembro de este documento': 'Eliminar a ' + member_name + ' del documento'"
              confirm
              [confirmBody]="isCurrentUser(member) ? '¿Estás seguro de que quieres dejar de ser miembro de este documento?': '¿Estás seguro de que quieres eliminar a ' + member_name + ' del documento?'"
              [confirmTitle]="isCurrentUser(member) ? 'Dejar de ser miembro' : 'Eliminar miembro del documento'"
              (onConfirm)="removeMember(member)"
            >
              <mat-icon>logout</mat-icon>
            </button>
          }
        </div>
      </div>
    </div>
  }
}
@placeholder {
  
  @if (error()) {
    <div class="error-message">
      Error al cargar los propietarios del documento.
    </div>
  } @else {
    @for(i of [1,2,3,4,5]; track $index) {
      <div class="list-item">
        <div class="list-item-image">
          <div class="list-item-image-container skeleton">
          </div>
        </div>
        <div class="list-item-content">
          <div class="list-item-content-left" style="width: 100%;">
            <div class="skeleton skeleton-text"></div>
            <div class="skeleton skeleton-text"></div>
            <div class="skeleton skeleton-text"></div>
          </div>
        </div>
      </div>
    }
  }
}
